<div class="row">
  <div class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
    <div class="!tw-rounded-2xl tw-mb-[25px] tw-bg-white dark:tw-bg-[#27323e] tw-p-5 tw-h-[calc(100%-25px)]">

      <div class="tw-h-full tw-flex tw-flex-col">
        <div class="tw-items-center tw-justify-center tw-flex">
          <h1 class=" tw-flex tw-gap-4">
            <span>{{ 'lang.globals.welcomeDashboard' |translate }}</span>
            <div
              class="!tw-size-12 tw-bg-cover tw-bg-center tw-bg-no-repeat tw-bg-[url(assets/seatback-logos/adplacer.png)] dark:tw-bg-[url(assets/seatback-logos/adplacerWhite.png)]"></div>
          </h1>
        </div>
        <div class="tw-w-full tw-flex tw-gap-5 tw-flex-col sm:tw-flex-row sm:tw-h-full tw-mt-5">
          <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full ">
            <div class="tw-relative tw-group">
              @if (userStatus?.user?.user?.avatar?.url) {
                <div [style.backgroundImage]="'url('+userStatus?.user?.user?.avatar?.url+'?thumbnail=S)'"
                     class="!tw-size-30 tw-rounded-full tw-bg-cover tw-bg-center tw-bg-no-repeat">
                </div>
              } @else {
                <div
                  class="!tw-size-30 tw-rounded-full tw-bg-sbGray-50 dark:tw-bg-[#1d2025] tw-flex tw-justify-center tw-items-center">
                  <sb-icon icon="user" class="tw-text-5xl"></sb-icon>
                </div>
              }
              <div class="tw-absolute tw-hidden tw-bottom-1 tw-right-1 group-hover:tw-block">
                <button type="button" sb-button-primary [color]="'blue'" [icon]="'edit'" [iconButton]="true" (click)="pickProfileImage()">
                </button>
              </div>
            </div>
            <div class="tw-text-2xl !tw-font-bold tw-mt-5">{{ userStatus?.user?.user.name }}</div>
            <div class="tw-flex tw-gap-2">
              @if (userStatus?.user?.client?.primaryCompany?.logo?.url) {
                <div [style.backgroundImage]="'url('+userStatus?.user?.client?.primaryCompany?.logo?.url+'?thumbnail=S)'"
                     class="!tw-size-6 tw-bg-cover tw-bg-center tw-bg-no-repeat">
                </div>
              }
              <div class="tw-text-sbGray-500 tw-text-xl tw-font-semibold">{{ userStatus?.user?.client?.name }}</div>
            </div>
            <!--
            <div class="userContainer">
              <div class="userContainer__details">
                <div class="userContainer__details__username tw-text-3xl !tw-font-bold">{{ userStatus?.user?.user.name }}</div>
              </div>
              @if (userStatus?.user?.user?.avatar?.url) {
                <div [style.backgroundImage]="'url('+userStatus?.user?.user?.avatar?.url+'?thumbnail=S)'"
                     class="userContainer__picBg !tw-size-20">
                </div>
              }
            </div>
            <div class="tw-text-xl tw-mt-6">{{ 'lang.globals.currentClient' |translate }}</div>
            <div class="userContainer">
              <div class="userContainer__details">
                <div class="userContainer__details__companyname tw-text-2xl tw-font-semibold">{{ userStatus?.user?.client?.name }}</div>
              </div>
              @if (userStatus?.user?.client?.primaryCompany?.logo?.url) {
                <div [style.backgroundImage]="'url('+userStatus?.user?.client?.primaryCompany?.logo?.url+'?thumbnail=S)'"
                     class="userContainer__picBg">
                </div>
              }
            </div>
            -->
            <div class="tw-mt-5 tw-text-xl tw-flex tw-gap-4 tw-text-sbGray-700">
              <sb-icon [icon]="'calendar'"></sb-icon>
              <div>{{ today.toString() | date: 'dd.MM.yy' }}</div>
              <div>|</div>
              <div>{{ today.toString() | date: 'HH:mm' }}</div>
            </div>

            <div class="tw-text-xl tw-flex tw-gap-4 tw-items-center tw-text-sbGray-700">
              <sb-icon [icon]="'plannings'"></sb-icon>
              <div>{{ 'lang.globals.cw' | translate }} {{ today.get('localWeekNumber') }}</div>
              <div>|</div>

              <div>{{ today.startOf('week').toString() | date: 'dd.MM.yy' }}
                - {{ today.endOf('week').toString() | date: 'dd.MM.yy' }}
              </div>
            </div>
          </div>
          <div
            class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-sbGray-50 dark:tw-bg-[#1d2025] tw-rounded-2xl tw-p-8">
            <div class="tw-text-lg tw-mb-5 tw-font-semibold">{{ 'lang.globals.quickStart' |translate }}</div>
            @if (permissionService.hasPermissions([permissionService.Permission.campaign_list, permissionService.Permission.device_list, permissionService.Permission.medium_list, permissionService.Permission.medium_group_list])) {
              <ul
                class="tw-flex tw-flex-col tw-gap-4 tw-w-full ">
                @if (permissionService.hasPermission(permissionService.Permission.campaign_list)) {
                  <li
                    class="">
                    <a [sbRouterLink]="util.RoutingID.campaigns"
                       class=" tw-flex tw-justify-center tw-items-center hover:tw-bg-sbBlue-800 *:!tw-text-white tw-cursor-pointer tw-bg-sbBlue-500 tw-rounded-full tw-p-2 tw-w-full"><span>
                  <sb-icon class="mr-1" icon="management"></sb-icon>
                      {{ 'permission.campaign_show' | translate }}
                </span></a>
                  </li>
                }
                @if (permissionService.hasPermission(permissionService.Permission.device_list)) {
                  <li
                    class="">
                    <a
                      [sbRouterLink]="util.RoutingID.devices"
                      class=" tw-flex tw-justify-center tw-items-center hover:tw-bg-sbBlue-800 *:!tw-text-white tw-cursor-pointer tw-bg-sbBlue-500 tw-rounded-full tw-p-2 tw-w-full"><span>
                  <sb-icon class="mr-1" icon="playerOnline"></sb-icon>
                      {{ 'lang.globals.openDeviceList' | translate }}
                </span></a>
                  </li>
                }
                @if (permissionService.hasPermission(permissionService.Permission.medium_list)) {
                  <li
                    class="">
                    <a [sbRouterLink]="util.RoutingID.mediumExplorer"
                       class=" tw-flex tw-justify-center tw-items-center hover:tw-bg-sbBlue-800 *:!tw-text-white tw-cursor-pointer tw-bg-sbBlue-500 tw-rounded-full tw-p-2 tw-w-full"><span>
                  <sb-icon class="mr-1" icon="motiveExplorer"></sb-icon>
                      {{ 'lang.globals.openMotives' | translate }}
                </span></a>
                  </li>
                }
                @if (permissionService.hasPermission(permissionService.Permission.medium_group_list)) {
                  <li
                    class="">
                    <a [sbRouterLink]="util.RoutingID.mediumGroup"
                       class=" tw-flex tw-justify-center tw-items-center hover:tw-bg-sbBlue-800 *:!tw-text-white tw-cursor-pointer tw-bg-sbBlue-500 tw-rounded-full tw-p-2 tw-w-full"><span>
                  <sb-icon class="mr-1" icon="motives"></sb-icon>
                      {{ 'lang.globals.openMotiveGroups' | translate }}
                </span></a>
                  </li>
                }
              </ul>
            } @else {
              <i class="tw-font-light"> {{ 'lang.globals.noQuickStart' | translate }} </i>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (!hideInfoTile) {
    <div class="col-lg-3 col-sm-12 col-xs-12">
      @if (loadingClientInfo) {
        <sb-loading-spinner></sb-loading-spinner>
      } @else {

        <div
          class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-sbBlue-100  tw-rounded-2xl tw-p-8 tw-h-[calc(100%-25px)]">
          <div class="tw-text-lg tw-mb-5 tw-font-semibold tw-flex tw-gap-2"
               [ngbTooltip]="'lang.globals.missingOptionsDescription' |translate" container="body">
            <sb-icon icon="attention"></sb-icon>
            <div>
              {{ 'lang.globals.missingOptions' |translate }}
            </div>
          </div>
          <ul
            class="tw-flex tw-flex-col tw-gap-4 tw-w-full ">
            @for (missingOption of missingOptions; track $index) {
              <li
                class="">
                <a [sbRouterLink]="missingOption.link"
                   class=" tw-flex tw-justify-center tw-items-center hover:tw-bg-sbBlue-800 *:!tw-text-white tw-cursor-pointer tw-bg-sbBlue-500 tw-rounded-full tw-p-2 tw-w-full"><span>
                  <sb-icon class="mr-1" [icon]="missingOption.icon"></sb-icon>
                  {{ missingOption.label }}
                </span></a>
              </li>
            }
          </ul>
          @if (hasOpenMissingOptions) {
            <div
              class=" tw-flex tw-justify-center tw-items-center !tw-text-white  tw-rounded-full tw-p-2 tw-w-full">
              {{ 'lang.globals.additionalMissingOptions' | translate }}
            </div>
          }
        </div>
      }
    </div>
  }
  @if (hasDevices) {
    <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
      <sb-network-overview-reporting></sb-network-overview-reporting>
    </div>
    <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
      <sb-player-time-data [from]="from" [till]="till" [resolveInCom]="false" [inputData]="reportData"
      ></sb-player-time-data>
    </div>
    <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
      <sb-comp-service-time-data [from]="from" [till]="till" [resolveInCom]="false" [inputData]="reportData"
      ></sb-comp-service-time-data>
    </div>
    <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-12">
      <sb-comp-heatmap-status [from]="from" [till]="till"></sb-comp-heatmap-status>
    </div>
  }
  <ng-container *ngIf="util.getSeatbackCMSClient() !== 'pmg'">
    <div *ngPermissions="[permissionService.Permission.ds_cm_reporting]" class="col-xxl-8 col-xl-12 col-lg-12 col-sm-12 col-xs-12">
      <!--<sb-bid-impression-rate></sb-bid-impression-rate>-->
      <sb-playouts-overall></sb-playouts-overall>
      <sb-playouts-per-publisher></sb-playouts-per-publisher>
    </div>
  </ng-container>

  <div *ngPermissions="[permissionService.Permission.campaign_list]" class="col-xxl-4 col-xl-12 col-lg-12 col-sm-12 col-xs-12">
    <div sb-campaign-preview-slider [campaigns]="campaigns" [companyId]="companyId" class="slideAnimation fill h-100 carousel-fullHeight">
    </div>
  </div>
</div>

<!--  <div class="col-lg-4 col-xs-12">
    <sb-card classes="blue-bg">
      <div card-fit>
        <fa-icon icon="photos-video"></fa-icon>
        <h2>Campaigns</h2>
        <h5>Manage Campaigns</h5>
      </div>
    </sb-card>
  </div>

  <div class="col-lg-4 col-xs-12">
    <sb-card classes="blue-bg">
      <div card-fit>
        <fa-icon icon="photos-video"></fa-icon>
        <h2>Campaigns</h2>
        <h5>Manage Campaigns</h5>
      </div>
    </sb-card>
  </div>

  <div class="col-lg-4 col-xs-12">
    <sb-card classes="blue-bg">
      <div card-fit>
        <fa-icon icon="photos-video"></fa-icon>
        <h2>Campaigns</h2>
        <h5>Manage Campaigns</h5>
      </div>
    </sb-card>
  </div>
</div>-->

<div *sbPageAction>
  <!--  <sb-chart-control [from]="from" [till]="till" [interval]="interval" (dateChange)="setTimeFrame($event)" (intervalChange)="setInterval($event)"></sb-chart-control>
  <sb-button classes="btn-primary mr-0" disabled>
     <fa-icon icon="cog"></fa-icon> {{'lang.dashboard.customize' | translate}}
   </sb-button>-->
</div>
